"use client";

import React, { useRef } from "react";
import { cn } from "@/lib/utils";
import { AnimatedBeam } from "@/app/components/ui/animated-beam";
import { MessageCircle, FileText, CheckCircle, Star } from "lucide-react";
import { useResponsive } from "@/app/hooks/useResponsive";
import Circle from "../ui/circle";

export function Engagement() {
	const { isLg } = useResponsive()
  const containerRef = useRef<HTMLDivElement>(null);

  const circleRefs = [
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
    useRef<HTMLDivElement>(null),
  ];

  const beams = circleRefs.map((ref, i) => {
    const nextRef = circleRefs[(i + 1) % circleRefs.length];
    return { fromRef: ref, toRef: nextRef };
  });

  const steps = [
    {
      Icon: MessageCircle,
      title: "Conversa inicial",
      description: "Entendemos suas necessidades e sonhos.",
    },
    {
      Icon: FileText,
      title: "Proposta personalizada",
      description: "Criamos o projeto sob medida.",
    },
    {
      Icon: CheckCircle,
      title: "Execução impecável",
      description: "Do conceito à entrega, cuidamos de cada detalhe.",
    },
    {
      Icon: Star,
      title: "Resultado memorável",
      description: "Você e seu público jamais esquecerão.",
    },
  ];

  return (
    <div
      className="relative flex w-full items-center justify-center overflow-hidden"
      ref={containerRef}
    >
      <div className="flex w-full flex-col gap-10 mx-auto">
        <div className="flex lg:justify-between md:justify-between justify-center flex-wrap gap-8 px-6 lg:px-0">
          {steps.map(({ Icon, title, description }, i) => (
            <div
              key={`step-${i}`}
              className="flex flex-col items-center text-center"
            >
              <Circle ref={circleRefs[i]} className="mb-4">
                <Icon
                  size={24}
                  className={cn(
                    i === steps.length - 1 ? "text-amber-300" : "text-[#101820]"
                  )}
                />
              </Circle>
              <h3 className="text-lg md:text-xl font-semibold  text-[#005BFF]">
                {title}
              </h3>
              <p className="mt-1 text-sm md:text-base text-gray-500 lg:max-w-[160px] max-w-full">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
      {isLg &&
        beams.map((beam, i) => (
          <AnimatedBeam
            key={i}
            duration={3}
            containerRef={containerRef}
            fromRef={beam.fromRef}
            toRef={beam.toRef}
            gradientStartColor="#5BE5FF"
            gradientStopColor="#307AFF"
          />
        ))}
    </div>
  );
}
